import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';

import { RequestService } from '../services/request.service';

type GraphQlVariables = Record<string, unknown>;

/**
 * Public-viewer stand-in for {@link JepRequestService}.
 * Table paging/sort `getCardData` must use IAM guest GraphQL (`RequestService`).
 * Mutations are no-ops so share links never persist card edits.
 */
@Injectable()
export class AnalyticsJepRequestAdapter {
	private readonly requestService = inject(RequestService);

	query(args: {
		query: string;
		variables?: GraphQlVariables;
		fetchPolicy?: string;
	}): Observable<unknown> {
		const { query, variables = {} } = args;
		return this.requestService.query({ query, variables });
	}

	mutate(args: {
		mutation: string;
		variables?: GraphQlVariables;
	}): Observable<unknown> {
		const variables = args.variables ?? {};
		const input =
			variables['input'] &&
			typeof variables['input'] === 'object' &&
			!Array.isArray(variables['input'])
				? (variables['input'] as GraphQlVariables)
				: undefined;

		const cardId = String(
			input?.['cardId'] ?? variables['cardId'] ?? ''
		);
		const rawRevisions = input?.['revisions'] ?? variables['revisions'] ?? 1;
		const revisions = Number(rawRevisions);
		const safeRevisions =
			Number.isFinite(revisions) && revisions > 0 ? revisions : 1;
		const dateUpdated = new Date().toISOString();
		const payload = {
			cardId,
			title: '',
			revisions: safeRevisions,
			dateUpdated,
		};

		const mutationText = args.mutation ?? '';
		if (mutationText.includes('restoreCardVersion')) {
			return of({ data: { restoreCardVersion: payload } });
		}

		return of({ data: { updateCard: payload } });
	}
}
